import './Hero.css';

function Hero() {
  return (
    <div className="hero">
      <h1 className="hero__title">Федерация лыжных гонок Саратовской области</h1>
    </div>
  );
}

export default Hero;